import ResumegptLogoV1 from '/imports/extensionOnboarding/assets/ResumegptLogoV1';
import styled from 'styled-components';
import { useResponsive } from '/imports/core/api/responsiveContext';
import Flex from '/imports/core/ui/atoms/Flex';
import { getBrandName } from '/lib/helpers';

const HeaderV1 = () => {
  const { host } = useResponsive();

  return (
    <Main fullWidth alignItems="center" justifyContent="center">
      <Logo alignItems="center">
        <LogoWrapper>
          <ResumegptLogoV1 />
        </LogoWrapper>
        <BrandLogo> {getBrandName(true, host)}</BrandLogo>
      </Logo>
    </Main>
  );
};

export default HeaderV1;

const Logo = styled(Flex)`
  gap: 12px;
`;
const BrandLogo = styled.span`
  color: #1d2c43;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  font-family: ${({ theme }) => theme.font.family.websiteSemiBold};
`;
const LogoWrapper = styled(Flex)`
  svg {
    height: 24px;
    width: 24px;
  }
  flex-shrink: 0;
`;

const Main = styled(Flex)`
  padding: 24px 0;
  gap: 12px;
  border-bottom: 1px solid var(--grayscale-n200);
  justify-content: space-between;
  height: 68px;
  padding: 12px 40px;
  background: #fff;
`;

const Nav = styled(Flex)`
  gap: 8px;
`;

const TitleHeaderWrapper = styled(Flex)`
  height: 32px;
  padding: 16px;
  gap: 8px;
  border-radius: 28px;
  border: 1px solid #e2e8f1;
  background: #f3f6fa;
  cursor: pointer;
`;

const SkipButton = styled.button`
  cursor: pointer;
  min-width: 120px;
  height: 34px;
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 32px;
  border: 1px #f3f6fa solid;
  background: #f3f6fa;
  color: #4f5e75;
  text-align: center;
  font-family: ${({ theme }) => theme.font.family.websiteSemiBold};
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
`;

const LocaleWrapper = styled(Flex)`
  height: 32px;
  padding: 4px 12px 4px 16px;
  align-items: center;
  gap: 8px;
`;

const Icon = styled.div`
  margin-top: 5px;
`;
